<template>
  <div>
    <v-alert v-if="error" type="error" class="mb-0">
      {{ error }}
    </v-alert>

    <div class="d-flex justify-space-between align-center flex-wrap mb-4 gap-4">
      <v-card elevation="0" :loading="loading" class="flex-grow-1">
        <div class="pa-1 d-flex">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Busque por nome ou domínio"
            single-line
            outlined
            hide-details
            clearable
            dense
            class="flex-grow-1"
          />
          <v-btn
            color="primary"
            class="ml-2"
            @click="$router.push({ name: 'admin.platforms.create' })"
          >
            <v-icon left>mdi-plus</v-icon>
            Nova Plataforma
          </v-btn>
        </div>
      </v-card>
    </div>

    <v-alert color="primary" text class="mb-0" dense>
      <div class="d-flex justify-space-between align-center">
        Forçar deploy de todas as plataformas
        <v-btn
          color="primary"
          @click="forceAllDeployments"
          :loading="loadingForceAll"
          small
        >
          Forçar
        </v-btn>
      </div>
    </v-alert>

    <v-row>
      <v-col
        v-for="platform in filteredPlatforms"
        :key="platform.id"
        cols="12"
        md="12"
      >
        <platform-card :platform="platform" :loading="loading" />
      </v-col>
    </v-row>

    <!-- Modal de Prévia -->
    <v-dialog v-model="previewModal" max-width="800">
      <v-card>
        <v-card-title>Prévia da Plataforma</v-card-title>
        <v-card-text>
          <pre>{{ JSON.stringify(newPlatform, null, 2) }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import PLATFORM from "@/services/admin/platform";
import PlatformCard from "@/components/ultimate/platform/PlatformCard.vue";
import { mapGetters } from "vuex";

export default {
  name: "Platforms",
  metaInfo: {
    title: "Plataformas",
  },
  components: {
    PlatformCard,
  },
  data: () => ({
    loading: false,
    loadingForceAll: false,
    error: null,
    search: "",
    platforms: [],
    previewModal: false,
    creating: false,
    newPlatform: {
      name: "",
      domain: "",
      email: "",
      phone: "",
      legalInfo: {
        document: "",
        legalName: "",
        fantasyName: "",
      },
      socialNetworks: [],
      hidePoweredBy: false,
      colors: {
        dark: {
          primary: "#003cfa",
          secondary: "#434343",
          brandPrimary: "#ffffff",
          brandSecondary: "#0d8adc",
        },
        light: {
          primary: "#003cfa",
          secondary: "#434343",
          brandPrimary: "#ffffff",
          brandSecondary: "#0d8adc",
        },
        appBar: "#272727",
        footerBar: "#272727",
      },
      logos: {
        dark: "",
        light: "",
        favicon: "",
        background: "",
        videoCover: "",
      },
      active: true,
    },
  }),
  methods: {
    async getPlatforms() {
      try {
        this.loading = true;
        this.error = null;
        const data = await PLATFORM.getAll();
        this.platforms = data.platforms;
      } catch (error) {
        console.log(error);
        this.error = error.message || "Erro ao buscar plataformas";
      } finally {
        this.loading = false;
      }
    },
    async forceAllDeployments() {
      try {
        this.loadingForceAll = true;
        this.error = null;
        await PLATFORM.forceAllDeployments();
      } catch (error) {
        console.log(error);
        this.error = error.message || "Erro ao forçar deploy";
      } finally {
        this.loadingForceAll = false;
      }
    },
    previewPlatform() {
      this.previewModal = true;
    },
  },
  computed: {
    ...mapGetters("company", ["selectedCompany"]),
    filteredPlatforms() {
      if (!this.search) return this.platforms;

      return this.platforms.filter(
        (platform) =>
          platform.name.toLowerCase().includes(this.search.toLowerCase()) ||
          platform.domain.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  watch: {
    "selectedCompany.id"() {
      this.platforms = [];
      this.getPlatforms();
    },
  },
  mounted() {
    this.getPlatforms();
  },
};
</script>
  
  <style></style>
  